import { render, staticRenderFns } from "./inline.round.items.vue?vue&type=template&id=08a1ae47&"
import script from "./inline.round.items.vue?vue&type=script&lang=js&"
export * from "./inline.round.items.vue?vue&type=script&lang=js&"
import style0 from "./inline.round.items.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports